import { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import api from "../api"; // já está configurado, né?

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const Input = styled.input`
  width: 200px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

const Button = styled.button`
  padding: 10px 20px;
  background-color: #2c73d2;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

const TelaLogin = ({ setUser }) => {
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");

  const handleLogin = async () => {
    try {
      var chamada = { login, senha };

      const response = await api.post("liga/login", chamada);
      localStorage.setItem("user", JSON.stringify(response.data));
      setUser(response.data);
      toast.success("Login realizado!");
    } catch (error) {
      toast.error("Login inválido!");
    }
  };

  return (
    <LoginContainer>
      <h2>Login</h2>
      <Input
        type="text"
        placeholder="Login"
        value={login}
        onChange={(e) => setLogin(e.target.value)}
      />
      <Input
        type="password"
        placeholder="Senha"
        value={senha}
        onChange={(e) => setSenha(e.target.value)}
      />
      <Button onClick={handleLogin}>Entrar</Button>
    </LoginContainer>
  );
};

export default TelaLogin;
